// src/screens/DisclaimerScreen.js - Improved version
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const DisclaimerScreen = ({ onAccept }) => {
  const [isChecked, setIsChecked] = useState(false);
  const navigate = useNavigate();

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const handleAccept = () => {
    if (isChecked) {
      onAccept();

      // Preserve URL parameters when navigating
      const queryParams = new URLSearchParams(window.location.search);
      const hasParams = queryParams.toString();

      if (hasParams) {
        navigate("/personal-info?" + queryParams.toString());
      } else {
        navigate("/personal-info");
      }
    }
  };

  return (
    <div className="screen-container">
      <h1 className="screen-title">Welcome to SipNScore</h1>

      <div className="disclaimer-text">
        <h3>Age Verification and Privacy Notice</h3>
        <p>Before you proceed, please read and accept the following terms:</p>

        <h4>Age Verification</h4>
        <p>
          By using this app, you confirm that you are 18 years of age or older.
          The consumption of alcoholic beverages is only permitted for
          individuals of legal drinking age?
        </p>

        <h4>Privacy Notice (POPI Act Compliance)</h4>
        <p>
          Your privacy is important to us. In accordance with the Protection of
          Personal Information Act (POPI Act), we'd like to inform you that:
        </p>
        <ul>
          <li>
            The personal information you provide will be stored securely and
            used only for the purposes of this promotion.
          </li>
          <li>
            Your data may be shared with the event organizer, the featured
            brands, and relevant third parties involved in this promotion.
          </li>
          <li>
            We will retain your information for marketing purposes and to send
            you information about future promotions and products.
          </li>
          <li>
            You have the right to access, correct, or delete your personal
            information by contacting us.
          </li>
        </ul>

        <h4>Terms of Use</h4>
        <p>
          By proceeding, you agree to use this app responsibly and in accordance
          with all applicable laws and regulations.
        </p>
      </div>

      <div className="checkbox-container">
        <input
          type="checkbox"
          id="accept-checkbox"
          checked={isChecked}
          onChange={handleCheckboxChange}
        />
        <label htmlFor="accept-checkbox">
          I confirm that I am 18 years of age or older and I accept the terms
          and conditions.
        </label>
      </div>

      <button className="button" onClick={handleAccept} disabled={!isChecked}>
        Continue
      </button>
    </div>
  );
};

export default DisclaimerScreen;
